<template>
<div class="chapter">
<div class="inner_page">
<p style="margin-top:0em; margin-bottom:0em; text-align:center; text-indent:0em;"><img alt="" height="100%" src="images/cover.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Cover.vue?175ec0ed